import jsonp from 'jsonp'
import CodeGrid from '@/utils/CodeGrid'
import { AccountRequest } from '@/config/http'

/**
 * 公共接口请求国家码
 * @description
 */
export function requestCountryCode() {
  return new Promise((resolve) => {
    jsonp('HTTP://gd.GeoBytes.com/GetCityDetails?callback=?', undefined, (error1, data): void => {
      if (error1) {
        jsonp('HTTP://FreeGeoIP.net/json/?callback=?', undefined, (error2, data2): void => {
          if (error2) {
            jsonp('HTTP://IP-API.com/json?callback=?', undefined, (error3, data3) => {
              if (error3) {
                jsonp('HTTP://WWW.GeoPlugIn.net/json.gp?jsoncallback=?', undefined, (error4, data4) => {
                  if (error4) {
                    jsonp('HTTP://IPinfo.IO/json', undefined, (error5, data5) => {
                      if (error5) {
                        console.log('IP查询失败')
                        resolve({
                          error: 'IP查询失败'
                        })
                      }
                      // recountry(data5.country);
                      resolve({ code: data5.country })
                    })
                  }
                  // recountry(data4.geoplugin_countryCode);
                  resolve({ code: data4.geoplugin_countryCode })
                })
              }
              // recountry(data3.countryCode);
              resolve({ code: data3.countryCode })
            })
          }
          // recountry(data2.country_code);
          resolve({ code: data2.country_code })
        })
      }
      // recountry(data.geobytesinternet);
      resolve({ code: data.geobytesinternet })
    })
  })
}

/**
 * GEO判断国家码
 * @description
 */
export function requestGEO() {
  return new Promise((resolve) => {
    // 请求GEO地理信息，重置 国家码、country
    // const {geolocation} = navigator;
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((result: any) => {
        let position = result
        // 此文件不需要打包，独立放在一个地址，可以大幅减少打包部署时间。
        const grid = CodeGrid.CodeGrid(`/hmaccount/v3/geoCodeGrid/`)
        position = position.coords
        grid.getCode(position.latitude, position.longitude, function (error: any, code: any) {
          if (code) {
            // 从json文件解析国家码
            resolve({ code })
          }
          // jsonp请求验证国家码
          else resolve({ error })
        })
      })
    }
  })
}

/**
 * 获取国家码
 */
export function getRecommendCountry() {
  return AccountRequest({
    url: '/recommendCountry',
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

/**
 * (NEW)获取推荐国家
 */
export function getRecommendCountryV2() {
  return AccountRequest({
    url: '/v1/client/recommendArea',
    method: 'GET'
  })
}
